module.exports = __webpack_public_path__ + "static/media/part-03.81c52069.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-03.jpg
// module id = 936
// module chunks = 0